/**
 * The media kit tab. Every other tab is a row of the reference the editors keep;
 * this one is a page of its own, always last in the tab bar
 */
export const JOURNAL_ADVERTISING_TAB_KEY = 'advertising';
export const JOURNAL_ADVERTISING_TAB_LABEL = 'Реклама';

/** One tab of the tab bar */
export interface JournalTabItem {
  key: string;
  label: string;
  to: string;
}

/** One chip of a filter row: editions on a tab, years in the archive block */
export interface JournalChip {
  key: string | number;
  label: string;
  to: string;
  active: boolean;
}
